/* HobbyChef — datová vrstva pro Google Tag Manager (formát GA4 ecommerce,
   developers.google.com/analytics/devguides/collection/ga4/ecommerce).

   Theme jen posílá události do window.dataLayer; co se z nich stane (GA4,
   Ads, Sklik…), nastavuje analytik v GTM. Popis všech událostí a polí je
   v analytics/DATALAYER.md.

   Každá ecommerce událost jde jako dvojice:
     dataLayer.push({ ecommerce: null });
     dataLayer.push({ event: 'add_to_cart', ecommerce: { currency, value, items } });
   (vynulování, jinak by GTM slil položky s předchozí událostí). Ceny jsou
   v měně košíku (CZK, pro Slovensko EUR) s DPH jako čísla, value = součet
   price × quantity.

   Doplněno 24. 9. 2026 na žádost analytika (analytics/DATALAYER.md,
   Konvence hodnot a §10 Historie změn):
     value_net   value bez DPH vedle value — theme sazbu DPH nezná (košík
                 ani produkt ji nenesou), počítá se sazbou VAT_RATE po
                 řádcích stejně jako Shopify: DPH = round(cena × 21/121);
                 přesnou hodnotu u purchase posílá až checkout pixel
     feed_id     ID položky v Merchant Center, FEED_PREFIX podle měny
                 + product_id + '_' + variant_id
     item_type   'addon' u pouzdra a gravírování připojených k noži
                 (surová data `addon: true` z panelu košíku)

   Odkud se co bere:
     window.hcDLPage          snippets/hc-datalayer.liquid (měna, typ stránky,
                              produkt na produktovce, dotaz ve vyhledávání)
     [data-hc-dl-item]        karta produktu — surová data ze snippets/
                              hc-dl-raw.liquid, převádí je jediný převodník item()
     [data-hc-dl-list]        seznam karet (kategorie, hledání, bestsellery,
                              pásy na produktovce, průvodce, tipy v košíku)
     [data-hc-dl-cart]        stav košíku v panelu (sections/hc-cart-drawer.liquid),
                              mění se s každým překreslením panelu
     [data-hc-dl-event]       značka úspěchu vykreslená serverem (newsletter)

   Změny košíku v panelu hlásí assets/hobbychef-cart.js přes hcDL.cartDiff():
   stav před akcí proti stavu po překreslení, sečtený po variantách — klíč
   řádku se mění se změnou vlastností (gravírování, pouzdro), varianta ne.
   Hlásí se jen varianty a kusy, které akce opravdu zapisuje (`limit`).

   Události při načtení stránky (view_item, search, view_cart, seznamy) čekají
   na první známý stav souhlasu z lišty cookies (hc:consent-ready, nejvýš
   2 s), jinak by značky se souhlasem utekly vracejícímu se zákazníkovi.

   V editoru themu hcDLPage chybí a nic se neposílá. Chyba tady nesmí
   rozbít košík — hobbychef-cart.js volá hcDL jen v try/catch. */
(function () {
  'use strict';

  var PAGE = window.hcDLPage || null;
  var ON = !!PAGE;
  var MAX_ITEMS = 200;          /* GA4 bere nejvýš 200 položek v události */
  var LIST_DELAY = 300;         /* dávkování zobrazených karet */
  var LIST_MAX_WAIT = 1500;     /* při plynulém scrollu nejpozději po téhle době */
  var CONSENT_WAIT = 2000;
  var HIDDEN_FILTER = /\s*-tag:skryta-polozka/g;
  /* DPH pro value_net. Všechno zboží je 21 %, Slovákům se účtuje česká
     DPH (EU mikropodnik, 22. 9. 2026). Stejné konstanty má checkout pixel. */
  var VAT_RATE = 0.21;
  /* ID v Merchant Center podle měny (= trhu): CZK → CZ, EUR → SK. Kdyby
     Merchant Center ukazoval jiný tvar (třeba shopify_ZZ_), mění se jen
     tady a v analytics/checkout-pixel.js. */
  var FEED_PREFIX = { CZK: 'shopify_CZ_', EUR: 'shopify_SK_' };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function layer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  /* ---- převodník položky ------------------------------------------------- */

  function filled(v) { return v !== undefined && v !== null && String(v).trim() !== ''; }
  function round2(n) { return Math.round(n * 100) / 100; }

  function fromCents(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    return isFinite(n) ? round2(n / 100) : null;
  }

  /* Id bez nuly — 0 vrací jen offline renderer, když produkt nemá id. */
  function idOf(v) { return filled(v) && String(v) !== '0' ? String(v) : ''; }

  function currency() { return (PAGE && PAGE.currency) || 'CZK'; }

  /* Surová data (tvar řádku z /cart.js) → položka GA4. Prázdná pole se
     vynechávají. `extra` doplní index, seznam nebo přebije množství. */
  function item(raw, extra) {
    if (!raw || typeof raw !== 'object') return null;
    var out = {};
    var sku = filled(raw.sku) ? String(raw.sku).trim() : '';
    var vid = idOf(raw.variant_id);
    var pid = idOf(raw.product_id);
    if (sku || vid) out.item_id = sku || vid;
    if (filled(raw.product_title)) out.item_name = String(raw.product_title);
    if (filled(raw.vendor)) out.item_brand = String(raw.vendor);
    if (filled(raw.product_type)) out.item_category = String(raw.product_type);
    if (filled(raw.variant_title) && raw.variant_title !== 'Default Title') out.item_variant = String(raw.variant_title);
    var price = fromCents(raw.price);
    if (price !== null) out.price = price;
    var discount = fromCents(raw.discount);
    if (discount) out.discount = discount;
    var q = parseInt(raw.quantity, 10);
    out.quantity = q > 0 ? q : 1;
    if (pid) out.product_id = pid;
    if (vid) out.variant_id = vid;
    if (raw.addon === true) out.item_type = 'addon';
    /* Zboží bez DPH: jen pro value_net, do dataLayer nejde (nevyčíslitelná
       vlastnost Object.keys ani GTM nevidí). */
    if (raw.taxable === false) Object.defineProperty(out, 'hcNoVat', { value: true });
    if (extra) {
      Object.keys(extra).forEach(function (k) {
        if (extra[k] !== undefined && extra[k] !== null && extra[k] !== '') out[k] = extra[k];
      });
    }
    return out;
  }

  function valueOf(items) {
    var sum = 0;
    items.forEach(function (it) { sum += (it.price || 0) * (it.quantity || 1); });
    return round2(sum);
  }

  /* Hodnota bez DPH jako v Shopify: DPH se počítá z každého řádku
     (cena × kusy) a zaokrouhluje na setiny, bez DPH = s DPH − DPH. */
  function netOf(items) {
    var sum = 0;
    items.forEach(function (it) {
      var gross = round2((it.price || 0) * (it.quantity || 1));
      sum += it.hcNoVat ? gross : gross - round2(gross * VAT_RATE / (1 + VAT_RATE));
    });
    return round2(sum);
  }

  /* Kopie položky s feed_id podle měny události. */
  function withFeedId(it, cur) {
    var out = {};
    Object.keys(it).forEach(function (k) { out[k] = it[k]; });
    var prefix = FEED_PREFIX[cur];
    if (prefix && it.product_id && it.variant_id && !out.feed_id) {
      out.feed_id = prefix + it.product_id + '_' + it.variant_id;
    }
    return out;
  }

  /* ---- odeslání ---------------------------------------------------------- */

  /* push('add_to_cart', { items: [...] }) — měnu, value, value_net
     a feed_id položek doplní sám. Bez ecommerce (search, generate_lead)
     jde jen událost s `extra`. */
  function push(event, ecommerce, extra) {
    if (!ON || !event) return false;
    var msg = { event: event };
    if (ecommerce) {
      var items = (ecommerce.items || []).filter(Boolean).slice(0, MAX_ITEMS);
      if (!items.length) return false;
      var e = { currency: ecommerce.currency || currency() };
      e.value = typeof ecommerce.value === 'number' ? round2(ecommerce.value) : valueOf(items);
      e.value_net = typeof ecommerce.value_net === 'number' ? round2(ecommerce.value_net) : netOf(items);
      Object.keys(ecommerce).forEach(function (k) {
        if (k !== 'items' && k !== 'currency' && k !== 'value' && k !== 'value_net' && ecommerce[k] !== undefined) e[k] = ecommerce[k];
      });
      e.items = items.map(function (it) { return withFeedId(it, e.currency); });
      msg.ecommerce = e;
    }
    if (extra) {
      Object.keys(extra).forEach(function (k) {
        if (k !== 'event' && k !== 'ecommerce' && extra[k] !== undefined) msg[k] = extra[k];
      });
    }
    var l = layer();
    if (msg.ecommerce) l.push({ ecommerce: null });
    l.push(msg);
    return true;
  }

  /* ---- košík ------------------------------------------------------------- */

  /* Aktuální stav košíku z panelu: { currency, items: [surová data + key,
     quantity] }. Bez panelu null. */
  function cart() {
    var box = document.querySelector('[data-hc-cd-contents]');
    var el = (box && box.querySelector('script[data-hc-dl-cart]')) || document.querySelector('script[data-hc-dl-cart]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent || '');
      if (!data || !Array.isArray(data.items)) return null;
      return { currency: data.currency || currency(), items: data.items };
    } catch (e) {
      return null;
    }
  }

  /* Součty po variantách, v pořadí prvního výskytu. Doplněk se sčítá
     zvlášť (klíč „varianta|addon“): totéž pouzdro může být v košíku jako
     doplněk k noži i koupené samostatně a každé nese jiný item_type. */
  function lineId(l) { return String(l.variant_id) + (l.addon === true ? '|addon' : ''); }

  function byVariant(snap) {
    var out = { order: [], qty: {}, raw: {} };
    ((snap && snap.items) || []).forEach(function (l) {
      if (!l) return;
      var id = lineId(l);
      if (!Object.prototype.hasOwnProperty.call(out.qty, id)) {
        out.order.push(id);
        out.qty[id] = 0;
        out.raw[id] = l;
      }
      out.qty[id] += parseInt(l.quantity, 10) || 0;
    });
    return out;
  }

  /* Rozdíl dvou stavů → jedno add_to_cart (kladné rozdíly) a jedno
     remove_from_cart (záporné). Sčítá se po variantách, ne po klíči řádku:
     změna gravírování nebo pouzdra u nože změní klíč, ale nic se nepřidalo.
     `limit` (nepovinné, { klíč: ±kusů }, klíč „varianta“ nebo
     „varianta|addon“) = co akce zapisuje: hlásí se jen tyhle varianty,
     jen tím směrem a nejvýš tolik kusů. Panel zápisy neřadí za sebe, takže
     se tím do rozdílu nepřimíchá souběžná akce ani reconcile() (zápis
     systému). Limit dostane řádek se stejným klíčem. Řádek, jehož klíč
     v limitu není, smí vzít limit druhého klíče téže varianty (Liquid
     a akce se neshodnou, zda jde o doplněk). Dohromady se limit varianty
     nepřekročí. */
  function cartDiff(before, after, limit) {
    if (!before || !after) return null;
    var a = byVariant(before);
    var b = byVariant(after);
    var adds = [];
    var removes = [];
    var has = function (o, k) { return Object.prototype.hasOwnProperty.call(o, k); };
    var ids = [];
    var seen = {};
    b.order.concat(a.order).forEach(function (id) {
      if (!seen[id]) { seen[id] = true; ids.push(id); }
    });
    var change = {};
    var got = {};
    ids.forEach(function (id) { change[id] = (b.qty[id] || 0) - (a.qty[id] || 0); got[id] = limit ? 0 : change[id]; });
    if (limit) {
      var left = {};
      Object.keys(limit).forEach(function (k) { left[k] = parseInt(limit[k], 10) || 0; });
      var take = function (slot, d) {
        var max = left[slot] || 0;
        var t = max > 0 ? Math.max(0, Math.min(d, max)) : Math.min(0, Math.max(d, max));
        if (t) left[slot] = max - t;
        return t;
      };
      ids.forEach(function (id) { if (has(left, id)) got[id] = take(id, change[id]); });
      ids.forEach(function (id) {
        var vid = id.split('|')[0];
        [vid, vid + '|addon'].forEach(function (slot) {
          var rest = change[id] - got[id];
          if (slot !== id && rest && has(left, slot) && !has(limit, id)) got[id] += take(slot, rest);
        });
      });
    }
    ids.forEach(function (id) {
      var d = got[id];
      if (d > 0) adds.push(item(b.raw[id] || a.raw[id], { quantity: d }));
      else if (d < 0) removes.push(item(a.raw[id] || b.raw[id], { quantity: -d }));
    });
    var cur = after.currency || before.currency;
    if (adds.length) push('add_to_cart', { currency: cur, items: adds });
    if (removes.length) push('remove_from_cart', { currency: cur, items: removes });
    return { add: adds, remove: removes };
  }

  /* view_cart, begin_checkout — celý košík. Prázdný se nehlásí. */
  function cartEvent(name, snap) {
    snap = snap || cart();
    if (!snap || !snap.items || !snap.items.length) return false;
    return push(name, { currency: snap.currency, items: snap.items.map(function (l) { return item(l); }) });
  }

  /* ---- seznamy: view_item_list, select_item ------------------------------ */

  function listOf(card) { return card.closest ? card.closest('[data-hc-dl-list]') : null; }

  function cardsIn(list) {
    return Array.prototype.filter.call(list.querySelectorAll('[data-hc-dl-item]'), function (c) {
      return listOf(c) === list;
    });
  }

  function listInfo(list) {
    return {
      id: list.getAttribute('data-hc-dl-list') || '',
      name: list.getAttribute('data-hc-dl-list-name') || '',
      offset: parseInt(list.getAttribute('data-hc-dl-list-offset'), 10) || 0
    };
  }

  function rawOf(card) {
    if (card.hcDLRaw === undefined) {
      try { card.hcDLRaw = JSON.parse(card.getAttribute('data-hc-dl-item') || 'null'); }
      catch (e) { card.hcDLRaw = null; }
    }
    return card.hcDLRaw;
  }

  /* Položka karty s pozicí v seznamu (od nuly, mezi kartami s daty v pořadí
     v DOM, + posun stránkování). */
  function cardItem(card, list) {
    list = list || listOf(card);
    if (!list) return null;
    var info = listInfo(list);
    var pos = cardsIn(list).indexOf(card);
    return item(rawOf(card), {
      index: pos < 0 ? undefined : pos + info.offset,
      item_list_id: info.id,
      item_list_name: info.name
    });
  }

  var reported = {};      /* seznam|pozice|id → karta už nahlášená */
  var queue = {};         /* seznam → { name, items } čekající na odeslání */
  var queueTimer = null;
  var queueSince = 0;

  function flush() {
    if (queueTimer) window.clearTimeout(queueTimer);
    queueTimer = null;
    queueSince = 0;
    var q = queue;
    queue = {};
    Object.keys(q).forEach(function (id) {
      var items = q[id].items.sort(function (x, y) { return (x.index || 0) - (y.index || 0); });
      for (var i = 0; i < items.length; i += MAX_ITEMS) {
        push('view_item_list', { item_list_id: id, item_list_name: q[id].name, items: items.slice(i, i + MAX_ITEMS) });
      }
    });
  }

  /* Karta se ukázala: jednou za stránku, v dávce po seznamech. */
  function shown(card) {
    var list = listOf(card);
    if (!list) return;
    var it = cardItem(card, list);
    if (!it) return;
    var key = it.item_list_id + '|' + it.index + '|' + it.item_id;
    if (reported[key]) return;
    reported[key] = true;
    if (!queue[it.item_list_id]) queue[it.item_list_id] = { name: it.item_list_name, items: [] };
    queue[it.item_list_id].items.push(it);
    var now = Date.now();
    if (!queueSince) queueSince = now;
    if (queueTimer) window.clearTimeout(queueTimer);
    queueTimer = window.setTimeout(flush, now - queueSince >= LIST_MAX_WAIT ? 0 : LIST_DELAY);
  }

  function hasBox(el) { return !!(el.getClientRects && el.getClientRects().length); }

  var io = null;
  var watched = [];

  function watch(card) {
    if (card.hcDLWatched) return;
    card.hcDLWatched = true;
    if (io) {
      watched.push(card);
      io.observe(card);
    } else if (hasBox(card)) {
      /* Bez IntersectionObserver: všechny vykreslené karty hned. */
      shown(card);
    }
  }

  /* Nové karty (tipy v překresleném panelu…) a úklid odpojených. */
  function scan() {
    if (io) {
      watched = watched.filter(function (c) {
        if (c.isConnected === false) { io.unobserve(c); return false; }
        return true;
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-hc-dl-list] [data-hc-dl-item]'), watch);
  }

  function startLists() {
    if ('IntersectionObserver' in window) {
      io = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          /* 0,49: prohlížeče občas hlásí 0,4999 místo prahu 0,5. */
          if (!e.isIntersecting || e.intersectionRatio < 0.49) return;
          io.unobserve(e.target);
          shown(e.target);
        });
      }, { threshold: 0.5 });
    }
    scan();
    if ('MutationObserver' in window && document.body) {
      var t = null;
      new window.MutationObserver(function () {
        if (t) return;
        t = window.setTimeout(function () { t = null; scan(); }, 200);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---- kliknutí a formuláře ---------------------------------------------- */

  function query(href) {
    var out = {};
    var s = String(href || '');
    var i = s.indexOf('?');
    if (i < 0) return out;
    s.slice(i + 1).split('#')[0].split('&').forEach(function (pair) {
      if (!pair) return;
      var kv = pair.split('=');
      try { out[decodeURIComponent(kv[0])] = decodeURIComponent((kv[1] || '').replace(/\+/g, ' ')); }
      catch (e) { /* rozbitý parametr přeskočit */ }
    });
    return out;
  }

  function lineFor(snap, q) {
    if (!snap || !snap.items) return null;
    if (q.line) return snap.items[parseInt(q.line, 10) - 1] || null;
    if (q.id) {
      return snap.items.filter(function (l) { return String(l.key) === q.id; })[0] ||
        snap.items.filter(function (l) { return String(l.variant_id) === q.id; })[0] || null;
    }
    return null;
  }

  /* Tlačítko, kterým se odeslal formulář na /cart. SubmitEvent.submitter
     starší Safari nezná a tlačítko po kliknutí ani nedostane fokus. */
  var lastSubmit = null;

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('input[type="submit"], button[type="submit"], button:not([type])');
    lastSubmit = btn && btn.form ? btn : null;

    /* select_item: odkaz nebo tlačítko karty v seznamu. Navigaci se nebrání. */
    var card = t.closest('[data-hc-dl-item]');
    if (card) {
      var hit = t.closest('a[href], button');
      var list = listOf(card);
      if (hit && list && (hit === card || card.contains(hit))) {
        flush();                      /* view_item_list téže karty dřív */
        var it = cardItem(card, list);
        if (it) push('select_item', { item_list_id: it.item_list_id, item_list_name: it.item_list_name, items: [it] });
      }
    }

    /* /cart (Skeleton sections/cart.liquid): odkaz „Odebrat“ vede na
       /cart/change?line=N&quantity=0 (nebo id=klíč). */
    var a = t.closest('a[href*="/cart/change"]');
    var q = a ? query(a.getAttribute('href')) : null;
    if (q && q.quantity === '0') {
      var snap = cart();
      var line = lineFor(snap, q);
      if (line) push('remove_from_cart', { currency: snap.currency, items: [item(line)] });
    }
  }

  function isCartForm(form) {
    var action = String(form.getAttribute('action') || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    return /(^|\/)cart$/.test(action) && String(form.getAttribute('method') || '').toLowerCase() === 'post';
  }

  /* Stav košíku podle hodnot formuláře na /cart: updates[] jde po pořadí
     řádků, updates[klíč] podle klíče (nebo varianty). */
  function formCart(form, snap) {
    var fields = Array.prototype.filter.call(form.elements || [], function (el) {
      return el.name && el.name.indexOf('updates') === 0 && !el.disabled;
    });
    if (!fields.length) return null;
    var items = snap.items.map(function (l) {
      var c = {};
      Object.keys(l).forEach(function (k) { c[k] = l[k]; });
      return c;
    });
    var pos = 0;
    fields.forEach(function (el) {
      var target = null;
      if (el.name === 'updates[]') {
        target = items[pos];
        pos += 1;
      } else {
        var k = el.name.slice(8, -1);
        target = items.filter(function (l) { return String(l.key) === k; })[0] ||
          items.filter(function (l) { return String(l.variant_id) === k; })[0] || null;
      }
      var q = parseInt(el.value, 10);
      if (target && !isNaN(q) && q >= 0) target.quantity = q;
    });
    return {
      currency: snap.currency,
      items: items.filter(function (l) { return (parseInt(l.quantity, 10) || 0) > 0; })
    };
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || String(form.tagName).toUpperCase() !== 'FORM' || !isCartForm(form)) return;
    var before = cart();
    if (!before) return;
    var after = formCart(form, before);
    if (after) cartDiff(before, after);
    var sub = e.submitter || (lastSubmit && lastSubmit.form === form ? lastSubmit : null) || document.activeElement;
    lastSubmit = null;
    if (sub && sub.name === 'checkout' && (!sub.form || sub.form === form)) cartEvent('begin_checkout', after || before);
  }

  /* ---- události při načtení stránky -------------------------------------- */

  function whenConsent(fn) {
    var done = false;
    function go() {
      if (done) return;
      done = true;
      fn();
    }
    if (window.hcDLConsentReady) { go(); return; }
    document.addEventListener('hc:consent-ready', go);
    window.setTimeout(go, CONSENT_WAIT);
  }

  /* Dotaz bez skrytého přívěsku, který přidává hledání (sections/hc-search.liquid). */
  function searchTerm(terms) {
    return String(terms || '').replace(HIDDEN_FILTER, '').trim();
  }

  /* Značka se stejnou adresou se v jedné relaci hlásí jednou — obnovení
     stránky s potvrzením newsletteru není další přihlášení. */
  function firstTime(key) {
    try {
      if (window.sessionStorage.getItem(key)) return false;
      window.sessionStorage.setItem(key, '1');
    } catch (e) { /* bez úložiště hlásit vždy */ }
    return true;
  }

  function markers() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hc-dl-event]'), function (el) {
      var name = el.getAttribute('data-hc-dl-event');
      if (!name) return;
      var params = {};
      try { params = JSON.parse(el.getAttribute('data-hc-dl-params') || '{}') || {}; }
      catch (e) { params = {}; }
      if (firstTime('hc-dl:' + name + ':' + window.location.pathname + window.location.search)) push(name, null, params);
    });
  }

  /* Typ načtení stránky: navigate, reload, back_forward. */
  function navType() {
    try {
      var perf = window.performance;
      var nav = perf && perf.getEntriesByType ? perf.getEntriesByType('navigation')[0] : null;
      if (nav && nav.type) return nav.type;
      if (perf && perf.navigation) return perf.navigation.type === 1 ? 'reload' : perf.navigation.type === 2 ? 'back_forward' : 'navigate';
    } catch (e) { /* bez Navigation Timing brát jako nové načtení */ }
    return 'navigate';
  }

  /* `search` jen za nové hledání: ne na 2. a další stránce výsledků
     (stránkování má přívěsek, nepřesměrovává se) a ne při obnovení
     stránky nebo návratu Zpět/Vpřed. */
  /* Nové hledání = formulář (ten `page` nikdy nenese). Parametr `page`
     přidává jen stránkovač, i „Předchozí strana“ zpět na page=1 —
     to už je listování ve výsledcích téhož dotazu. */
  /* Záložky Vše / Produkty / Články / Stránky a řazení výsledků
     (hc-search, 22. 9. 2026) načtou /search znovu se stejným dotazem.
     To není nové hledání, proto se nepočítá, když předchozí stránka
     byla /search se stejným `q` (porovnává se bez velikosti písmen
     a nadbytečných mezer). Nový dotaz z téže stránky se počítá. */
  function sameSearchAsReferrer() {
    try {
      var ref = document.referrer ? new URL(document.referrer) : null;
      if (!ref || ref.origin !== window.location.origin || ref.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return false;
      var norm = function (v) { return String(v || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
      return norm(query(ref.search).q) === norm(query(window.location.search).q);
    } catch (e) { return false; }
  }

  function newSearch() {
    if (Object.prototype.hasOwnProperty.call(query(window.location.search), 'page')) return false;
    var type = navType();
    if (type === 'reload' || type === 'back_forward') return false;
    return !sameSearchAsReferrer();
  }

  function pageEvents() {
    if (PAGE.product) push('view_item', { items: [item(PAGE.product)] });

    if (PAGE.search && newSearch()) {
      var term = searchTerm(PAGE.search.terms);
      if (term) {
        var p = { search_term: term };
        var n = parseInt(PAGE.search.results_count, 10);
        if (!isNaN(n)) p.search_results_count = n;
        push('search', null, p);
      }
    }

    if (PAGE.page_type === 'cart') cartEvent('view_cart');

    markers();
  }

  /* ---- veřejné rozhraní ---------------------------------------------------- */

  window.hcDL = {
    item: item,
    push: push,
    cart: cart,
    cartDiff: cartDiff,
    viewCart: function (snap) { return cartEvent('view_cart', snap); },
    beginCheckout: function (snap) { return cartEvent('begin_checkout', snap); },
    searchTerm: searchTerm,
    flush: flush
  };

  if (!ON) return;

  ready(function () {
    /* Hledání bez přívěsku se hned přesměrovává (hc-search.liquid) —
       události pošle až cílová stránka. */
    if (window.hcSearchRedirect) return;

    document.addEventListener('click', onClick);
    document.addEventListener('submit', onSubmit);
    /* Odchod ze stránky: dohnat čekající view_item_list. */
    window.addEventListener('pagehide', flush);

    whenConsent(function () {
      if (window.hcSearchRedirect) return;
      pageEvents();
      startLists();
    });
  });
}());
